/**
 * Persisted operation ids for the public booking API (BL-1513).
 *
 * The API runs only pre-approved documents named by id; it refuses a body
 * carrying its own query text. Each id is the SHA-256 of the document
 * registered on the backend in
 * `services/meeting/src/modules/v2/scheduling-public/manifest/manifests/current.manifest.json`.
 *
 * When the backend rotates a document its id changes and only this file
 * needs updating. The previous two generations stay accepted for a while, so
 * a stale id degrades gracefully rather than breaking the page at deploy.
 */
export const BOOKING_OPERATION_IDS = {
  SchedulingOffer:
    'e5fd7580fc88b2db141adaf9b959192b51b8e360cfcc0ce0c68e3e7da4779e79',
  Booking: '30d361dddb89a1718210b5501956a08ed2f0fb006b56a4f39339909007767c7d',
  HoldSlot: '36ea9acefc50c916689babdcb4f6d49715cd2259454d648339dff62c984ea1ed',
  ConfirmSlot:
    '810b0d184b294a8df0c970334beadc03eb7499fbb3b6f8b1d67d025ae07141c8',
  DeclineAll:
    'f351fd9e9618f56f106805baa369bef03dd4638974e2d0fe09aa23d6b9209bb6',
  CalendarFile:
    '1d67dacc8f9fa1c44e0a42f7ce0def73b2862c12fc2e752b47b63c9c15f5467e',
  CancelBookingAsCandidate:
    '2148529f0e33de3ed06e7908182d464cbb2accaa932fb66b6305a04af069932d',
  RescheduleBookingAsCandidate:
    'a036e85cefe95671f7af6ff19df682777d7ff65e74931cf76fe7506c7c5fff80',
} as const;

export type BookingOperationName = keyof typeof BOOKING_OPERATION_IDS;
